import { useState, useEffect } from "react"
import Navbar from "../../components/Navbar"
import Footer from "../../components/Footer"
import Table from "../../components/table/Table"
import { useParams } from "react-router-dom"
import { useApi } from "../../hooks/useApi"
import LoadingSpinner from "../loading/LoadingSpinner"
const LessonsTable = () => {
  const { lessonType } = useParams()
  const [name, setNameLesson] = useState("")
  const [lessonData, setLessonData] = useState([])

  const { fetchData, isLoading, error } = useApi()

  useEffect(() => {
    const fetchLessonData = async () => {
      try {
        let endpoint = ""
        if (lessonType === "comprehension" || lessonType === "storyboarding") {
          endpoint = `/lessons/reading/${lessonType}`
        } else if (lessonType === "sentence-dictation" || lessonType === "qa") {
          endpoint = `/lessons/listening/${lessonType}`
        } else if (lessonType === "storytelling" || lessonType === "conversation-exchange") {
          endpoint = `/lessons/speaking/${lessonType}`
        } else {
          endpoint = `/lessons/writing/${lessonType}`
        }

        const data = await fetchData(endpoint)
        setLessonData(data.lessons)
        setNameLesson(data.name)
        console.log("Fetched lesson data:", data)
      } catch (error) {
        console.error("Error fetching lesson data:", error)
      }
    }

    if (lessonType) {
      fetchLessonData()
    }
  }, [lessonType, fetchData])

  if (!lessonType) {
    return <div>No lesson type provided!</div>
  }

  if (isLoading) {
    return <LoadingSpinner />
  }

  if (error) {
    return <div>Error: {error.message}</div>
  }

  return (
    <div>
      <Navbar />
      <Table data={lessonData} lesson_type={name} />
      <Footer />
    </div>
  )
}

export default LessonsTable

